var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"section-filters"},[_c('PhonesFiltersSelected'),_c('div',{staticClass:"filters-list"},[_c('PhonesFiltersDropdowns'),_c('PhonesFiltersDate')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }